module.exports = __webpack_public_path__ + "img/white-lily.78c98119.webp";